import { render, staticRenderFns } from "./CatalogDrawer.vue?vue&type=template&id=2eeeff59&scoped=true&"
import script from "./CatalogDrawer.vue?vue&type=script&lang=js&"
export * from "./CatalogDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CatalogDrawer.vue?vue&type=style&index=0&id=2eeeff59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeeff59",
  null
  
)

export default component.exports